import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2912e4a3 = () => interopDefault(import('../../../pages/admin/index.vue' /* webpackChunkName: "pages/admin/index" */))
const _bdbe82ac = () => interopDefault(import('../../../pages/auth/index.vue' /* webpackChunkName: "pages/auth/index" */))
const _20ad0fd9 = () => interopDefault(import('../../../pages/axiostest.vue' /* webpackChunkName: "pages/axiostest" */))
const _4417d5b0 = () => interopDefault(import('../../../pages/dashboard/index.vue' /* webpackChunkName: "pages/dashboard/index" */))
const _14ed601c = () => interopDefault(import('../../../pages/error/index.vue' /* webpackChunkName: "pages/error/index" */))
const _017b9bd3 = () => interopDefault(import('../../../pages/group/index.vue' /* webpackChunkName: "pages/group/index" */))
const _c3df8d7e = () => interopDefault(import('../../../pages/manager/index.vue' /* webpackChunkName: "pages/manager/index" */))
const _b942efb8 = () => interopDefault(import('../../../pages/setting/index.vue' /* webpackChunkName: "pages/setting/index" */))
const _270b5b62 = () => interopDefault(import('../../../pages/student/index.vue' /* webpackChunkName: "pages/student/index" */))
const _29a99c5e = () => interopDefault(import('../../../pages/subscribe/index.vue' /* webpackChunkName: "pages/subscribe/index" */))
const _87fe5b70 = () => interopDefault(import('../../../pages/admin/active/index.vue' /* webpackChunkName: "pages/admin/active/index" */))
const _080a4062 = () => interopDefault(import('../../../pages/admin/migration/index.vue' /* webpackChunkName: "pages/admin/migration/index" */))
const _6ae294cf = () => interopDefault(import('../../../pages/admin/student/index.vue' /* webpackChunkName: "pages/admin/student/index" */))
const _a1e98244 = () => interopDefault(import('../../../pages/admin/subscribe/index.vue' /* webpackChunkName: "pages/admin/subscribe/index" */))
const _0886e6a0 = () => interopDefault(import('../../../pages/attendance/history/index.vue' /* webpackChunkName: "pages/attendance/history/index" */))
const _c7bc7b28 = () => interopDefault(import('../../../pages/attendance/status/index.vue' /* webpackChunkName: "pages/attendance/status/index" */))
const _6ac861c1 = () => interopDefault(import('../../../pages/auth/login.vue' /* webpackChunkName: "pages/auth/login" */))
const _1f5fec02 = () => interopDefault(import('../../../pages/auth/loginhelp.vue' /* webpackChunkName: "pages/auth/loginhelp" */))
const _371c5960 = () => interopDefault(import('../../../pages/manager/add.vue' /* webpackChunkName: "pages/manager/add" */))
const _4b70ae89 = () => interopDefault(import('../../../pages/manager/auth.vue' /* webpackChunkName: "pages/manager/auth" */))
const _00ad428f = () => interopDefault(import('../../../pages/manager/info.vue' /* webpackChunkName: "pages/manager/info" */))
const _2851a74c = () => interopDefault(import('../../../pages/manager/notification.vue' /* webpackChunkName: "pages/manager/notification" */))
const _7db348d8 = () => interopDefault(import('../../../pages/payment/payhistory.vue' /* webpackChunkName: "pages/payment/payhistory" */))
const _d486493c = () => interopDefault(import('../../../pages/room/history/index.vue' /* webpackChunkName: "pages/room/history/index" */))
const _6b38550c = () => interopDefault(import('../../../pages/room/status/index.vue' /* webpackChunkName: "pages/room/status/index" */))
const _7b1bb751 = () => interopDefault(import('../../../pages/setting/group.vue' /* webpackChunkName: "pages/setting/group" */))
const _3f551efb = () => interopDefault(import('../../../pages/setting/profile.vue' /* webpackChunkName: "pages/setting/profile" */))
const _02684a0e = () => interopDefault(import('../../../pages/stats/connect/index.vue' /* webpackChunkName: "pages/stats/connect/index" */))
const _1d6d8911 = () => interopDefault(import('../../../pages/stats/manager/index.vue' /* webpackChunkName: "pages/stats/manager/index" */))
const _6bd7a21f = () => interopDefault(import('../../../pages/stats/student/index.vue' /* webpackChunkName: "pages/stats/student/index" */))
const _52dfa26d = () => interopDefault(import('../../../pages/stats/study/index.vue' /* webpackChunkName: "pages/stats/study/index" */))
const _15ea5044 = () => interopDefault(import('../../../pages/student/add.vue' /* webpackChunkName: "pages/student/add" */))
const _0334cfc1 = () => interopDefault(import('../../../pages/student/info.vue' /* webpackChunkName: "pages/student/info" */))
const _599cbbe2 = () => interopDefault(import('../../../pages/study/history/index.vue' /* webpackChunkName: "pages/study/history/index" */))
const _12c5e4fa = () => interopDefault(import('../../../pages/study/status/index.vue' /* webpackChunkName: "pages/study/status/index" */))
const _b87c0e66 = () => interopDefault(import('../../../pages/subscribe/plan.vue' /* webpackChunkName: "pages/subscribe/plan" */))
const _3e853fdd = () => interopDefault(import('../../../pages/subscribe/unsubscribe.vue' /* webpackChunkName: "pages/subscribe/unsubscribe" */))
const _73dde407 = () => interopDefault(import('../../../pages/uielements/button.vue' /* webpackChunkName: "pages/uielements/button" */))
const _46eec425 = () => interopDefault(import('../../../pages/uielements/card.vue' /* webpackChunkName: "pages/uielements/card" */))
const _d06f6650 = () => interopDefault(import('../../../pages/uielements/checkbox.vue' /* webpackChunkName: "pages/uielements/checkbox" */))
const _2979bfe8 = () => interopDefault(import('../../../pages/uielements/modal.vue' /* webpackChunkName: "pages/uielements/modal" */))
const _086a065e = () => interopDefault(import('../../../pages/uielements/select.vue' /* webpackChunkName: "pages/uielements/select" */))
const _50403a78 = () => interopDefault(import('../../../pages/uielements/textinput.vue' /* webpackChunkName: "pages/uielements/textinput" */))
const _3da1ba5e = () => interopDefault(import('../../../pages/admin/student/add.vue' /* webpackChunkName: "pages/admin/student/add" */))
const _19a962d1 = () => interopDefault(import('../../../pages/study/history/today.vue' /* webpackChunkName: "pages/study/history/today" */))
const _77002223 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _5e956de2 = () => interopDefault(import('../../../pages/auth/manager/signup/_code.vue' /* webpackChunkName: "pages/auth/manager/signup/_code" */))
const _49d0046b = () => interopDefault(import('../../../pages/auth/resetpw/_code.vue' /* webpackChunkName: "pages/auth/resetpw/_code" */))
const _ab5eb226 = () => interopDefault(import('../../../pages/auth/signup/_code.vue' /* webpackChunkName: "pages/auth/signup/_code" */))
const _125f9648 = () => interopDefault(import('../../../pages/room/history/_roomId/index.vue' /* webpackChunkName: "pages/room/history/_roomId/index" */))
const _08520f40 = () => interopDefault(import('../../../pages/room/status/_roomId/index.vue' /* webpackChunkName: "pages/room/status/_roomId/index" */))
const _65e3a7e7 = () => interopDefault(import('../../../pages/stats/manager/_userId/index.vue' /* webpackChunkName: "pages/stats/manager/_userId/index" */))
const _74e2d2f5 = () => interopDefault(import('../../../pages/stats/student/_userId/index.vue' /* webpackChunkName: "pages/stats/student/_userId/index" */))
const _6c9f79b8 = () => interopDefault(import('../../../pages/study/history/_userId/index.vue' /* webpackChunkName: "pages/study/history/_userId/index" */))
const _324ed3c8 = () => interopDefault(import('../../../pages/admin/subscribe/_subscriptionId/history.vue' /* webpackChunkName: "pages/admin/subscribe/_subscriptionId/history" */))
const _647c86e0 = () => interopDefault(import('../../../pages/attendance/history/_userId/detail/index.vue' /* webpackChunkName: "pages/attendance/history/_userId/detail/index" */))
const _780aa8a8 = () => interopDefault(import('../../../pages/room/history/_roomId/info.vue' /* webpackChunkName: "pages/room/history/_roomId/info" */))
const _1e73416c = () => interopDefault(import('../../../pages/room/history/_roomId/status.vue' /* webpackChunkName: "pages/room/history/_roomId/status" */))
const _7f92a390 = () => interopDefault(import('../../../pages/room/status/_roomId/info.vue' /* webpackChunkName: "pages/room/status/_roomId/info" */))
const _63e82254 = () => interopDefault(import('../../../pages/room/status/_roomId/status.vue' /* webpackChunkName: "pages/room/status/_roomId/status" */))
const _6bc9f9c4 = () => interopDefault(import('../../../pages/study/history/_userId/detail/index.vue' /* webpackChunkName: "pages/study/history/_userId/detail/index" */))
const _4f2f8d86 = () => interopDefault(import('../../../pages/study/history/_userId/premium.vue' /* webpackChunkName: "pages/study/history/_userId/premium" */))
const _6c92f495 = () => interopDefault(import('../../../pages/study/history/_userId/studyHistory.vue' /* webpackChunkName: "pages/study/history/_userId/studyHistory" */))
const _75b1fdba = () => interopDefault(import('../../../pages/study/history/_userId/detail/premium.vue' /* webpackChunkName: "pages/study/history/_userId/detail/premium" */))
const _24abe9ca = () => interopDefault(import('../../../pages/manager/_managerId.vue' /* webpackChunkName: "pages/manager/_managerId" */))
const _0a1a198a = () => interopDefault(import('../../../pages/student/_studentId.vue' /* webpackChunkName: "pages/student/_studentId" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/admin",
    component: _2912e4a3,
    name: "admin"
  }, {
    path: "/auth",
    component: _bdbe82ac,
    name: "auth"
  }, {
    path: "/axiostest",
    component: _20ad0fd9,
    name: "axiostest"
  }, {
    path: "/dashboard",
    component: _4417d5b0,
    name: "dashboard"
  }, {
    path: "/error",
    component: _14ed601c,
    name: "error"
  }, {
    path: "/group",
    component: _017b9bd3,
    name: "group"
  }, {
    path: "/manager",
    component: _c3df8d7e,
    name: "manager"
  }, {
    path: "/setting",
    component: _b942efb8,
    name: "setting"
  }, {
    path: "/student",
    component: _270b5b62,
    name: "student"
  }, {
    path: "/subscribe",
    component: _29a99c5e,
    name: "subscribe"
  }, {
    path: "/admin/active",
    component: _87fe5b70,
    name: "admin-active"
  }, {
    path: "/admin/migration",
    component: _080a4062,
    name: "admin-migration"
  }, {
    path: "/admin/student",
    component: _6ae294cf,
    name: "admin-student"
  }, {
    path: "/admin/subscribe",
    component: _a1e98244,
    name: "admin-subscribe"
  }, {
    path: "/attendance/history",
    component: _0886e6a0,
    name: "attendance-history"
  }, {
    path: "/attendance/status",
    component: _c7bc7b28,
    name: "attendance-status"
  }, {
    path: "/auth/login",
    component: _6ac861c1,
    name: "auth-login"
  }, {
    path: "/auth/loginhelp",
    component: _1f5fec02,
    name: "auth-loginhelp"
  }, {
    path: "/manager/add",
    component: _371c5960,
    name: "manager-add"
  }, {
    path: "/manager/auth",
    component: _4b70ae89,
    name: "manager-auth"
  }, {
    path: "/manager/info",
    component: _00ad428f,
    name: "manager-info"
  }, {
    path: "/manager/notification",
    component: _2851a74c,
    name: "manager-notification"
  }, {
    path: "/payment/payhistory",
    component: _7db348d8,
    name: "payment-payhistory"
  }, {
    path: "/room/history",
    component: _d486493c,
    name: "room-history"
  }, {
    path: "/room/status",
    component: _6b38550c,
    name: "room-status"
  }, {
    path: "/setting/group",
    component: _7b1bb751,
    name: "setting-group"
  }, {
    path: "/setting/profile",
    component: _3f551efb,
    name: "setting-profile"
  }, {
    path: "/stats/connect",
    component: _02684a0e,
    name: "stats-connect"
  }, {
    path: "/stats/manager",
    component: _1d6d8911,
    name: "stats-manager"
  }, {
    path: "/stats/student",
    component: _6bd7a21f,
    name: "stats-student"
  }, {
    path: "/stats/study",
    component: _52dfa26d,
    name: "stats-study"
  }, {
    path: "/student/add",
    component: _15ea5044,
    name: "student-add"
  }, {
    path: "/student/info",
    component: _0334cfc1,
    name: "student-info"
  }, {
    path: "/study/history",
    component: _599cbbe2,
    name: "study-history"
  }, {
    path: "/study/status",
    component: _12c5e4fa,
    name: "study-status"
  }, {
    path: "/subscribe/plan",
    component: _b87c0e66,
    name: "subscribe-plan"
  }, {
    path: "/subscribe/unsubscribe",
    component: _3e853fdd,
    name: "subscribe-unsubscribe"
  }, {
    path: "/uielements/button",
    component: _73dde407,
    name: "uielements-button"
  }, {
    path: "/uielements/card",
    component: _46eec425,
    name: "uielements-card"
  }, {
    path: "/uielements/checkbox",
    component: _d06f6650,
    name: "uielements-checkbox"
  }, {
    path: "/uielements/modal",
    component: _2979bfe8,
    name: "uielements-modal"
  }, {
    path: "/uielements/select",
    component: _086a065e,
    name: "uielements-select"
  }, {
    path: "/uielements/textinput",
    component: _50403a78,
    name: "uielements-textinput"
  }, {
    path: "/admin/student/add",
    component: _3da1ba5e,
    name: "admin-student-add"
  }, {
    path: "/study/history/today",
    component: _19a962d1,
    name: "study-history-today"
  }, {
    path: "/",
    component: _77002223,
    name: "index"
  }, {
    path: "/auth/manager/signup/:code?",
    component: _5e956de2,
    name: "auth-manager-signup-code"
  }, {
    path: "/auth/resetpw/:code?",
    component: _49d0046b,
    name: "auth-resetpw-code"
  }, {
    path: "/auth/signup/:code?",
    component: _ab5eb226,
    name: "auth-signup-code"
  }, {
    path: "/room/history/:roomId",
    component: _125f9648,
    name: "room-history-roomId"
  }, {
    path: "/room/status/:roomId",
    component: _08520f40,
    name: "room-status-roomId"
  }, {
    path: "/stats/manager/:userId",
    component: _65e3a7e7,
    name: "stats-manager-userId"
  }, {
    path: "/stats/student/:userId",
    component: _74e2d2f5,
    name: "stats-student-userId"
  }, {
    path: "/study/history/:userId",
    component: _6c9f79b8,
    name: "study-history-userId"
  }, {
    path: "/admin/subscribe/:subscriptionId/history",
    component: _324ed3c8,
    name: "admin-subscribe-subscriptionId-history"
  }, {
    path: "/attendance/history/:userId/detail",
    component: _647c86e0,
    name: "attendance-history-userId-detail"
  }, {
    path: "/room/history/:roomId/info",
    component: _780aa8a8,
    name: "room-history-roomId-info"
  }, {
    path: "/room/history/:roomId/status",
    component: _1e73416c,
    name: "room-history-roomId-status"
  }, {
    path: "/room/status/:roomId/info",
    component: _7f92a390,
    name: "room-status-roomId-info"
  }, {
    path: "/room/status/:roomId/status",
    component: _63e82254,
    name: "room-status-roomId-status"
  }, {
    path: "/study/history/:userId/detail",
    component: _6bc9f9c4,
    name: "study-history-userId-detail"
  }, {
    path: "/study/history/:userId/premium",
    component: _4f2f8d86,
    name: "study-history-userId-premium"
  }, {
    path: "/study/history/:userId/studyHistory",
    component: _6c92f495,
    name: "study-history-userId-studyHistory"
  }, {
    path: "/study/history/:userId/detail/premium",
    component: _75b1fdba,
    name: "study-history-userId-detail-premium"
  }, {
    path: "/manager/:managerId",
    component: _24abe9ca,
    name: "manager-managerId"
  }, {
    path: "/student/:studentId",
    component: _0a1a198a,
    name: "student-studentId"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
